import React from 'react';

// Types
type ProfileDrawerActionType = 'OPEN_DRAWER' | 'CLOSE_DRAWER' | 'TOGGLE_DRAWER';
type ProfileDrawerAction = { type: ProfileDrawerActionType; payload?: boolean | string };

type ProfileDrawerDispatch = (action: ProfileDrawerAction) => void;

interface ProfileDrawerState {
  /** @boolean If the profile drawer is open */
  open: boolean;
}

const ProfileDrawerStateContext = React.createContext<ProfileDrawerState | undefined>(undefined);
const ProfileDrawerDispatchContext = React.createContext<ProfileDrawerDispatch | undefined>(
  undefined
);

const initialState: ProfileDrawerState = {
  open: false,
};

const sidebarReducer = (state: ProfileDrawerState, action: ProfileDrawerAction) => {
  switch (action.type) {
    case 'OPEN_DRAWER':
      return { ...state, open: true };
    case 'CLOSE_DRAWER':
      return { ...state, open: false };
    case 'TOGGLE_DRAWER':
      return { ...state, open: !state.open };
    default:
      return state;
  }
};

export const ProfileDrawerProvider: React.FC = ({ children }: any) => {
  const [state, dispatch] = React.useReducer(sidebarReducer, initialState);

  return (
    <ProfileDrawerStateContext.Provider value={state}>
      <ProfileDrawerDispatchContext.Provider value={dispatch}>
        {children}
      </ProfileDrawerDispatchContext.Provider>
    </ProfileDrawerStateContext.Provider>
  );
};

export const useProfileDrawerState = () => {
  const context = React.useContext(ProfileDrawerStateContext);
  if (context === undefined) {
    throw new Error('useProfileDrawerState must be used within a ProfileDrawerProvider');
  }
  return context;
};

export const useProfileDrawerDispatch = () => {
  const context = React.useContext(ProfileDrawerDispatchContext);
  if (context === undefined) {
    throw new Error('useProfileDrawerDispatch must be used within a ProfileDrawerProvider');
  }
  return context;
};
